@import "./../helpers/scss-helper";

:host {
  display: block;
  @include eon-typography();
}

.#{$prefix}contact-bar-item {
  cursor: pointer;
  max-width: 32px;
  transition: max-width 0.2s linear, background 0.2s linear;
  overflow: hidden;
  padding: 0 16px;
  min-height: 48px;
  align-items: center;
  display: flex;
  @include borderRadius("contact_bar", "content");

  eon-ui-button {
    --primaryBackgroundColor: var(--containerColor);
    --primaryBorderColor: var(--containerColor);
    --primaryTextAndIconColor: var(--innerContentColor);
    --primaryBackgroundHoverColor: var(--buttonHoverColor);
    --primaryBorderHoverColor: var(--buttonHoverColor);
    --primaryTextAndIconHoverColor: var(--containerColor);
    --focusBorderColor: var(--itemHoverColor);
  }

  &:hover {
    background: v(itemHoverColor);
    @include borderRadius("contact_bar", "content");

    eon-ui-button {
      --primaryBackgroundColor: var(--buttonHoverColor);
      --primaryBorderColor: var(--buttonHoverColor);
      --primaryTextAndIconColor: var(--containerColor);
    }
  }

  &__content {
    display: flex;
    flex-direction: row;
    color: unset;
    text-decoration: none;

    &:focus {
      outline-style: none;
    }

    &-icon {
      display: flex;
      position: relative;
      width: 32px;
      height: 32px;
      align-items: center;
      justify-content: center;

      eon-ui-button {
        justify-content: center;
        display: flex;
      }
    }

    &-link {
      @include eon-typography(copy);
      position: relative;
      padding-left: 16px;
      display: flex;
      flex-wrap: wrap;
      min-width: 90px;
      align-items: center;
      text-decoration: none;
      white-space: break-spaces;
      text-align: left;

      eon-ui-link {
        --fontWeight: #{$font-weight-medium};
        --fontSize: 14px;
        --lineHeight: 18px;
        --borderBottomWidth: 0;
        --contentColor: var(--innerContentColor) !important;
        --contentHoverColor: var(--innerContentColor) !important;
      }
    }
  }

  &__item {
    cursor: pointer;
    transition: max-width 0.2s linear, background 0.2s linear;
    overflow: hidden;
    padding: 0 16px;
    min-height: 48px;
    align-items: center;
    display: flex;
    @include borderRadius("contact_bar", "content");
    eon-ui-button {
      --primaryBackgroundColor: var(--containerColor);
      --primaryBorderColor: var(--containerColor);
      --primaryTextAndIconColor: var(--innerContentColor);
      --primaryBackgroundHoverColor: var(--buttonHoverColor);
      --primaryBorderHoverColor: var(--buttonHoverColor);
      --primaryTextAndIconHoverColor: var(--containerColor);
      --focusBorderColor: var(--itemHoverColor);
    }
    &:hover {
      background: v(itemHoverColor);
      @include borderRadius("contact_bar", "content");
      eon-ui-button {
        --primaryBackgroundColor: var(--buttonHoverColor);
        --primaryBorderColor: var(--buttonHoverColor);
        --primaryTextAndIconColor: var(--containerColor);
      }
    }
  }

  &__modal-item {
    display: flex;
    cursor: pointer;
    overflow: hidden;
    min-height: 48px;
    padding: 0 16px;
    align-items: center;
    @include borderRadius("contact_bar", "content");
    eon-ui-button {
      --primaryBackgroundColor: var(--containerColor);
      --primaryBorderColor: var(--containerColor);
      --primaryTextAndIconColor: var(--innerContentColor);
      --primaryBackgroundHoverColor: var(--buttonHoverColor);
      --primaryBorderHoverColor: var(--buttonHoverColor);
      --primaryTextAndIconHoverColor: var(--containerColor);
      --focusBorderColor: var(--itemHoverColor);
    }
    &:hover {
      background: v(itemHoverColor);
      @include borderRadius("contact_bar", "content");
      eon-ui-button {
        --primaryBackgroundColor: var(--buttonHoverColor);
        --primaryBorderColor: var(--buttonHoverColor);
        --primaryTextAndIconColor: var(--containerColor);
      }
    }
  }
  &__modal-content {
    display: flex;
    color: unset;
    text-decoration: none;
    width: 100%;
    &:focus {
      outline-style: none;
    }
    &-icon {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 32px;
      height: 32px;
    }
    &-link {
      @include eon-typography(copy);
      position: relative;
      white-space: break-spaces;
      text-align: left;
      padding-left: 16px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      text-decoration: none;
      eon-ui-link {
        --fontWeight: #{$font-weight-medium};
        --fontSize: 14px;
        --lineHeight: 18px;
        --borderBottomWidth: 0;
        --contentColor: var(--innerContentColor) !important;
        --contentHoverColor: var(--innerContentColor) !important;
      }
    }
  }
}

::slotted(eon-ui-contact-layer) {
  position: absolute;
  right: calc(100% - 32px);
  bottom: -48px;
  display: none;
  z-index: -1;

  @include for-size(phone) {
    right: 0;
    bottom: 0;
    width: 100%;
    height: auto;
    position: fixed;
    z-index: 300;
  }
}

::slotted(eon-ui-contact-layer[visible]) {
  display: block;
}

::slotted(eon-ui-contact-layer[visible="false"]) {
  display: none;
}